Browser = require '@trello/browser'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('onboarding')
l = require 'app/scripts/lib/localize'
{ trackUe } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{
  BOARD_NAME,
  LIST_NAME,
  CARD_NAME,
  CHECKITEM_NAME,
  CARD_DRAG,
  getInitialData,
  translatedCardDragFileMap,
  translatedCardBackFileMap,
} = require('app/scripts/views/onboarding/constants')
{ getTranslatedFile } = require('app/scripts/views/onboarding/helpers')
{ CreateFirstBoardIds } = require '@trello/test-ids'
Language = require '@trello/locale'
uuidv4 = require 'uuid/v4'

isInternetExplorer = Browser.isIE() || Browser.isEdge()

contentId = uuidv4()

module.exports = class CreateFirstBoardComponent extends React.Component

  constructor: (props) ->
    super

    @steps = [
      BOARD_NAME,
      LIST_NAME,
      CARD_NAME,
      CHECKITEM_NAME,
      CARD_DRAG
    ]

    urlParams = new URLSearchParams(window.location.search)
    selectedVertical = urlParams.get('selectedVertical')

    # If the user doesn't provide a vertical, give them the default experience.
    # This is also important because we will redirect in the controller if a vertical
    # is not provided, but if our feature flag is off, we will not. So defaulting here
    # is important
    if !selectedVertical
      selectedVertical = 'default'

    @state =
      currentStep: BOARD_NAME
      board: getInitialData(selectedVertical)
      saving: false
      hasStarted: false
      selectedVertical: selectedVertical

  skipToContent: -> @skipRef?.click()

  validate: ->
    { currentStep, board, selectedVertical } = @state
    INITIAL_DATA = getInitialData(selectedVertical)

    if currentStep == BOARD_NAME
      board.name != ''
    else if currentStep == LIST_NAME
      board.lists.filter((list) -> list.name != '').length == INITIAL_DATA.lists.length
    else if currentStep == CARD_NAME
      board.lists[0].cards[0].name != ''
    else if currentStep == CHECKITEM_NAME
      # Allow user to pass this step, some may not want to enter a checkitem
      true
    else
      true

  continue: ->
    if @isLastStep()
      @submit()
    else
      @goToStep(@steps[@steps.indexOf(@state.currentStep) + 1], 'by clicking on continue footer')

  submit: (isSkip = false) ->
    INITIAL_DATA = getInitialData(this.state.selectedVertical)
    if @state.saving
      return

    # before sending data to the submit callback, make sure to sanitize any data
    # like spaces in titles or empty inputs
    data = @state.board
    if data.name.trim() == ''
      data.name = INITIAL_DATA.defaultValue

    for list, index in data.lists
      if list.name.trim() == ''
        list.name = INITIAL_DATA.lists[index].name

    for card, index in data.lists[0].cards
      if card.name.trim() == ''
        card.name = INITIAL_DATA.lists[0].cards[index].defaultValue || ''

    if data.checkItem.trim() == ''
      data.checkItem = ''

    trackUe(
      'create first board view',
      'creates',
      'board',
      '',
      '',
      if isSkip then 'by clicking skip' else 'by clicking on the submit footer',
      {
        'currentStep': @state.currentStep,
        'stepCompleted': @validate(),
        'vertical': @state.selectedVertical,
      }
    )
    @setState({
      saving: true
    }, => @props.onSubmit(data))

  isLastStep: ->
    @steps.indexOf(@state.currentStep) == @steps.length - 1

  goToStep: (step, method) ->
    trackUe(
      'create first board view',
      'navigates',
      '',
      '',
      'to new step',
      method,
      {
        'currentStep': @state.currentStep,
        'nextStep': step,
        'stepCompleted': @validate(),
        'vertical': @state.selectedVertical,
      }
    )

    nextState = @state
    INITIAL_DATA = getInitialData(this.state.selectedVertical)
    # Some views we show more cards than others...
    if step != BOARD_NAME && step != LIST_NAME
      nextState.board.lists[1].cards = []
      nextState.board.lists[2].cards = []
    else
      nextState.board.lists[1].cards = INITIAL_DATA.lists[1].cards
      nextState.board.lists[2].cards = INITIAL_DATA.lists[2].cards

    nextState.currentStep = step
    nextState.hasStarted = true

    @setState(nextState)
    @skipToContent()

  handleClickBack: =>
    window.history.back()

  updateBoard: (value) ->
    @setState({
      board: Object.assign(@state.board, { name: value })
    })

  updateList: (index, value) ->
    nextState = @state
    @setState(=>
      nextState.board.lists[index] = {
        name: value
        cards: @state.board.lists[index].cards
      }
      nextState
    )

  updateCard: (index, value) ->
    nextState = @state
    @setState(=>
      nextState.board.lists[0].cards[index] = {
        name: value
      }
      nextState
    )

  updateCheckItem: (value) ->
    nextState = @state
    @setState(=>
      nextState.board.checkItem = value
      nextState
    )

  handleClickFooter: (e) ->
    # https://github.com/facebook/react/issues/3907
    if e.detail == 0
      return
    @continue()

  handleKeyPressSubmit: (e) ->
    if @validate() && e.key == 'Enter'
      @continue()

  handleListKeyPress: (e, index) ->
    if @validate() && e.key == 'Enter'
      if index in [0, 1]
        @["listInputRef#{index + 1}"].select()
      else
        @continue()

  renderStepChildren: ->
    { currentStep, board, selectedVertical, } = @state
    if currentStep == BOARD_NAME
      t.section ".#{BOARD_NAME}", =>
        t.h1 =>
          t.format "#{BOARD_NAME}:#{selectedVertical}:title"
        t.p =>
          t.format "#{BOARD_NAME}:#{selectedVertical}:description"
          t.span '.show-point-right', { role: 'presentation', 'aria-hidden': true },  =>
            t.format 'that-thing-over-there'
          t.span '.show-point-up', { role: 'presentation', 'aria-hidden': true }, =>
            t.format 'that-thing-up-there'
        t.p =>
          t.format "#{BOARD_NAME}:#{selectedVertical}:instructions"
        t.input {
          type: 'text'
          placeholder: t.l("#{BOARD_NAME}:#{selectedVertical}:placeholder:0")
          maxLength: "32"
          value: board.name
          onChange: (e) => @updateBoard(e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
          'data-test-id': CreateFirstBoardIds.BoardNameInput
          ref: (r) => (@ref0 = r)
          'aria-label': t.l 'board-name'
        }
    else if currentStep == LIST_NAME
      t.section ".#{LIST_NAME}", =>
        t.h1 =>
          t.format "#{LIST_NAME}:#{selectedVertical}:title"
        t.p =>
          t.format "#{LIST_NAME}:#{selectedVertical}:description"
        t.p =>
          t.format "#{LIST_NAME}:#{selectedVertical}:instructions"
        t.input {
          type: 'text'
          value: board.lists[0].name
          maxLength: "16"
          onChange: (e) => @updateList(0, e.target.value)
          onKeyPress: (e) => @handleListKeyPress(e, 0)
          'data-test-id': CreateFirstBoardIds.ListNameInput
          'aria-label': t.l 'list-name', { list_number: 1 }
        }
        t.input {
          type: 'text'
          value: board.lists[1].name
          maxLength: "16"
          onChange: (e) => @updateList(1, e.target.value)
          onKeyPress: (e) => @handleListKeyPress(e, 1)
          'aria-label': t.l 'list-name', { list_number: 2 }
        }
        t.div '.third-input', =>
          t.span =>
            t.format 'and'
          t.input {
            type: 'text'
            maxLength: "16"
            value: board.lists[2].name
            onChange: (e) => @updateList(2, e.target.value)
            onKeyPress: (e) => @handleListKeyPress(e, 2)
            'aria-label': t.l 'list-name', { list_number: 3 }
          }
        t.p '.post-input', =>
          t.format 'go-ahead-and-rename-your-lists-if-youd-like-a11y'
    else if currentStep == CARD_NAME
      t.section ".#{CARD_NAME}", =>
        t.h1 =>
          t.format "#{CARD_NAME}:#{selectedVertical}:title"
        t.p =>
          t.format "#{CARD_NAME}:#{selectedVertical}:description"
        t.p =>
          t.span {
            dangerouslySetInnerHTML: {
              __html: t.l(
                "#{CARD_NAME}:#{selectedVertical}:instructions",
                { listName: board.lists[0].name }
              )
            }
          }
        t.input {
          type: 'text'
          placeholder: t.l("#{CARD_NAME}:#{selectedVertical}:placeholder:0")
          maxLength: "32"
          value: board.lists[0].cards[0].name
          onChange: (e) => @updateCard(0, e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
          'data-test-id': CreateFirstBoardIds.CardNameInput
          ref: (r) => (@ref0 = r)
          'aria-label': t.l 'card-name', { card_number: 1 }
        }
        t.input {
          type: 'text'
          placeholder: t.l("#{CARD_NAME}:#{selectedVertical}:placeholder:1")
          maxLength: "32"
          value: board.lists[0].cards[1].name
          onChange: (e) => @updateCard(1, e.target.value)
          onKeyPress: (e) => @handleKeyPressSubmit(e)
          'aria-label': t.l 'card-name', { card_number: 2 }
        }
        t.div '.third-input', =>
          t.span =>
            t.format 'and'
          t.input {
            type: 'text'
            placeholder: t.l("#{CARD_NAME}:#{selectedVertical}:placeholder:2")
            maxLength: "32"
            value: board.lists[0].cards[2].name
            onChange: (e) => @updateCard(2, e.target.value)
            onKeyPress: (e) => @handleKeyPressSubmit(e)
            'aria-label': t.l 'card-name', { card_number: 3 }
          }
    else if currentStep == CHECKITEM_NAME
      t.section ".#{CHECKITEM_NAME}", =>
        t.h1 =>
          t.format "#{CHECKITEM_NAME}:#{selectedVertical}:title"
        t.p =>
          t.format "#{CHECKITEM_NAME}:#{selectedVertical}:description"
        t.p {
          dangerouslySetInnerHTML: {
            __html: t.l(
              "#{CHECKITEM_NAME}:#{selectedVertical}:instructions",
              { cardName: board.lists[0].cards[0].name }
            )
          }
        }
        t.div '.checklist-item', =>
          t.div '.checklist-box'
          t.input {
            type: 'text'
            placeholder: t.l("#{CHECKITEM_NAME}:#{selectedVertical}:placeholder:0")
            maxLength: "28"
            value: board.checkItem
            onChange: (e) => @updateCheckItem(e.target.value)
            onKeyPress: (e) => @handleKeyPressSubmit(e)
            'data-test-id': CreateFirstBoardIds.ChecklistInput
            ref: (r) => (@ref0 = r)
            'aria-label': t.l 'checklist-name'
          }
    else if currentStep == CARD_DRAG
      t.section ".#{CARD_DRAG}", =>
        # No changes to content based on vertical, just use default
        t.h1 =>
          t.format "#{CARD_DRAG}:default:title"
        t.p =>
          t.format "#{CARD_DRAG}:default:description"

  renderPreview: ->
    { currentStep, board, hasStarted } = @state
    firstList = board.lists[0]
    firstCard = firstList.cards[0]

    if currentStep == CARD_DRAG
      t.img {
        src: getTranslatedFile(translatedCardDragFileMap, Language.currentLocale)
      }
      t.div =>
        t.h2 =>
          t.format 'one-last-tip'
        t.p =>
          t.format 'get-those-cards-moving'
    else
      t.div '.board-name-display', =>
        t.p {
          className: t.classify({
            'is-active': !!board.name
          })
          'data-test-id': CreateFirstBoardIds.BoardNameDisplay
        }, => t.text board.name
      t.div '.first-board-image-list-container', =>
        for li, list of board.lists
          t.div '.first-board-image-list.list-name-display', {
            className: t.classify({
              'first-board-image-list-empty': list.cards.length == 0
            })
          }, =>
            t.p {
              className: t.classify({
                'is-active': hasStarted && list.name != ''
              })
              'data-test-id': if li == '0'
                CreateFirstBoardIds.ListNameDisplay
            }, =>
              if hasStarted
                t.text list.name
            for ci, card of list.cards
              t.div '.first-board-image-card.card-name-display', {
                className: t.classify({
                  'large': !!card.large
                })
              }, =>
                t.p {
                  className: t.classify({
                    'is-active': !!card.name
                  })
                  'data-test-id': if li == '0' && ci == '0'
                    CreateFirstBoardIds.CardNameDisplay
                }, => t.text card.name
      if currentStep == CHECKITEM_NAME
        t.div '.first-board-card-back', =>
          t.img {
            src: getTranslatedFile(translatedCardBackFileMap, Language.currentLocale)
            className: 'check-name-image'
          }
          t.div '.check-name-display', =>
            t.p => t.text firstCard.name || l('untitled card')
            if !board.checkItem
              t.p '.check-name-placeholder', =>
                t.format 'add-an-item'
            else
              t.p {
                'data-test-id': CreateFirstBoardIds.ChecklistDisplay
              }, => t.text board.checkItem

  renderFooter: ->
    { currentStep, saving } = @state

    t.button {
      key: "next-button:#{currentStep}"
      className: t.classify({
        'first-board-continue-footer': true
        'is-active': @validate() && !saving
        'submit-footer': @isLastStep()
        'disabled': !@validate() || saving
      })
      onClick: (e) => @handleClickFooter(e)
      onKeyDown: (e) => @handleKeyPressSubmit(e)
      'data-test-id': CreateFirstBoardIds.ContinueButton
      'disabled': !@validate() || saving
      ref: (r) => (@footer = r)
      'aria-label': if @isLastStep() then t.l('go-to-my-board') else t.l('next-step')
    }, =>
      if @isLastStep()
        t.format 'now-youre-a-pro-keep-building-your-board'
      else
        t.icon 'down', { role: 'presentation', 'aria-hidden': true }

  render: t.renderable ->
    { board, currentStep, hasStarted } = @state

    t.div '.first-board-container', =>
      if featureFlagClient.get('activation.onboarding_v2', false) && !hasStarted
        t.button '.button.first-board-back-button', {
          onClick: => @handleClickBack()
        }, =>
          t.format 'go-back'

      # mock board
      t.div '.first-board-column.first-board-image.board-name-background',
        {
          role: 'presentation',
          'aria-hidden': true
        }, =>
          t.div '.first-board-image-wrapper', =>
            t.div '.first-board-image-base', {
              className: t.classify({
                'first-board-image-base--mod-card-drag': currentStep == CARD_DRAG
                'first-board-image-base--mod-ie': currentStep == CHECKITEM_NAME &&
                  isInternetExplorer
              })
            }, =>
              @renderPreview()

      t.div '.first-board-column.first-board-content-wrapper', =>
        t.div '.first-board-content',  =>
          t.nav '.first-board-navigation', =>
            t.a '.skip-nav', {
              href: "##{contentId}",
              ref: (r) => (@skipRef = r)
            }, ->
              t.format('skip-nav')
            @steps.map (step, index) =>
              t.createElement('button', {
                key: "nav#{index}"
                className: t.classify({
                  'current-step': step == currentStep
                })
                onClick: => @goToStep(step, 'by clicking navigation dot')
                'aria-label': t.l("go-to-step:#{step}")
              })
          t.div '.first-board-text-wrapper', { 'aria-live': 'polite' }, =>
            t.div '.first-board-text', { id: contentId }, =>
              @renderStepChildren()
              @renderFooter()
